import React from "react";
import {
  Box,
  Chip,
  Col,
  FabButton,
  Flex,
  Row,
  Typography,

} from "../../../ppui";
import { AllowanceBox } from "../../style";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
const AllowanceList = ({ isFetching, allowanceListResponse, setAllowance, setAllowancedialogOpen, setErrors }) => {
  if (isFetching) {
    throw new Promise(() => { });
  }
 
  return (
    <Flex gap={20} direction={"column"}>
    {allowanceListResponse?.length > 1 ?
    <>
      {allowanceListResponse.slice(1).map((it) => (
        <AllowanceBox key={it?.allowanceName}>
          <Row alignItems="center">
            <Col>
              <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }} rowGap>
                <Col md={4} xl={3}>
                  <Box className="value">{it?.allowanceName} allowance</Box>
                  <Box className="value">
                    {it?.allowanceType === "percentage" ?
                      (<>{it?.allowanceValue}% of basic</>) :
                      (<>₹{it?.allowanceValue} {it?.allowanceType} Amount</>)
                    }
                  </Box>
                </Col>
                <Col >
                  <Box className="label">In Gorss Wages</Box>
                  <Box className="value" color={it?.addToGross ? "success" : "danger"}>{it?.addToGross ? "Included" :"Not Included"}</Box>
                </Col>
                <Col >
                  <Box className="label">In ESI Wages</Box>
                  <Box className="value" color={it?.isEsiWages ? "success" : "danger"}>{it?.isEsiWages ? "Included" :"Not Included"}</Box>
                </Col>
                <Col>
                  <Box className="label">In EPF Wages</Box>
                  <Box className="value" color={it?.isEpfWages ? "success" : "danger"}>
                    {it?.isEpfWages ? "Included" : "Not Included"}
                  </Box>
                </Col>
                <Col>
                  <Box className="label">Pay For</Box>
                  <Box className="value">{it?.noWorkNoPay ? "Present Days" : "Payable Days"}</Box>
                </Col>
                <Col>
                  <Box className="label">Status</Box>
                  <Box className="value">
                    <Chip
                      color={it?.status ? "success" : "danger"}
                      label={it?.status ? "Active" : "Inactive"}
                      onClick={() => {}}
                      size="sm"
                      dot
                    />
                  </Box>
                </Col>
              </Row>
            </Col>
            <Col sm={"auto"}>
              <FabButton
                icon={<TbPencil />}
                onClick={() => {
                  setAllowancedialogOpen(true);
                  setAllowance(it);
                  setErrors({});
                }}
                variant="filled"
                shape="box"
              />
            </Col>
          </Row>
        </AllowanceBox>
      ))}
      {allowanceListResponse?.[0] && (
        <AllowanceBox key={allowanceListResponse[0]?.allowanceName}>
          <Row alignItems="center">
            <Col>
              <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }} rowGap>
                <Col md={4} xl={3}>
                  <Box className="value">{allowanceListResponse[0]?.allowanceName} allowance</Box>
                  <Box className="value">
                    {allowanceListResponse[0]?.allowanceType === "percentage" ?
                      `${allowanceListResponse[0]?.allowanceValue}% of basic` :
                      `₹${allowanceListResponse[0]?.allowanceValue} ${allowanceListResponse[0]?.allowanceType} Amount`
                    }
                  </Box>
                </Col>
                <Col>
                  <Box className="label">In Gorss Wages</Box>
                  <Box className="value" color={allowanceListResponse[0]?.addToGross ? "success" : "danger"}>
                    {allowanceListResponse[0]?.addToGross ? "Included" : "Not Included"}
                  </Box>
                </Col>
                <Col>
                  <Box className="label">In ESI Wages</Box>
                  <Box className="value" color={allowanceListResponse[0]?.isEsiWages ? "success" : "danger"}>
                    {allowanceListResponse[0]?.isEsiWages ? "Included" : "Not Included"}
                  </Box>
                </Col>
                <Col>
                  <Box className="label">In EPF Wages</Box>
                  <Box className="value" color={allowanceListResponse[0]?.isEpfWages ? "success" : "danger"}>
                    {allowanceListResponse[0]?.isEpfWages ? "Included" : "Not Included"}
                  </Box>
                </Col>
                <Col>
                  <Box className="label">Pay For</Box>
                  <Box className="value">
                    {allowanceListResponse[0]?.noWorkNoPay ? "Present Days" : "Payable Days"}
                  </Box>
                </Col>
                <Col>
                  <Box className="label">Status</Box>
                  <Box className="value">
                    <Chip
                      color={allowanceListResponse[0]?.status ? "success" : "danger"}
                      label={allowanceListResponse[0]?.status ? "Active" : "Inactive"}
                      size="sm"
                      dot
                    />
                  </Box>
                </Col>
              </Row>
            </Col>
            <Col sm="auto">
              <FabButton
                icon={<TbPencil />}
                onClick={() => {
                  setAllowancedialogOpen(true);
                  setAllowance(allowanceListResponse[0]);
                  setErrors({});
                }}
                variant="filled"
                shape="box"
              />
            </Col>
          </Row>
        </AllowanceBox>
      )}
    </>
      :
      <AllowanceBox>
        <Typography variant="body1" display="flex" gap={10} alignItem="center" mb={"0"} p={15}>
          <TbAlertTriangle />
          No other allowances available
        </Typography>
      </AllowanceBox>
    }

</Flex>

  )
}

export default AllowanceList